import React from "react";
import { useGetProductsQuery } from "../../api";

import { Index as PosApplication } from "../../pages/application/pos";
import { Index as ECommerceApplication } from "../../pages/application/e-commerce";
import { Index as CashBackApplication } from "../../pages/application/cashback";
import { Index as BillingApplication } from "../../pages/application/billing";
import { Index as CompleteApplication } from "../../pages/application/notification";
import { ApplicationCreate } from "../../pages/application/ApplicationCreate";

export const useApplication = (props = {}) => {
  const { ProductType = null } = props;
  const { data, isLoading, isError, error } = useGetProductsQuery();
  const enhancedData = data ? [...data, "POS"] : ["POS"];
  // Detecting active Page

  const components = {
    POS: PosApplication,
    BILLING: BillingApplication,
    CASHBACK: CashBackApplication,
    ECOMERCE: ECommerceApplication,
    COMPLETE: CompleteApplication,
  };

  let ActiveComponent =
    ProductType &&
    components[ProductType] &&
    data &&
    (data.includes(ProductType) || ProductType === "COMPLETE")
      ? components[ProductType]
      : !ProductType && data && data.length && ApplicationCreate;

  return {
    ActiveComponent,
    isLoading,
    isError: Boolean(isError) || Boolean(error),
    needRedirect: !Boolean(ActiveComponent),
    data: enhancedData,
  };
};
